import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { JobgridService } from '../jobstatus/jobgrid.service';

import { PipeJobstatusService } from '../services/pipe-jobstatus/pipe-jobstatus.service';
import { NgxSpinnerService } from 'ngx-spinner';

import { OSPStateService } from '../services/osp-state.service';
import { forkJoin, interval, Subscription } from 'rxjs';
import { autoRefreshInterval, checkInvAccess, getTimezone } from '../constants';
import { warningMessage } from '../constants';
import * as mm from 'moment-timezone';
import * as moment from 'moment';

import { filter } from 'rxjs/operators';

import { Router } from '@angular/router';
import { StatusrenderComponent } from '../pipe-jobstatus/statusrender/statusrender.component';
import { LlpJobstatusBatchTriggerComponent } from './llp-jobstatus-batch-trigger/llp-jobstatus-batch-trigger.component';
import { BatchTriggerDialogComponent } from './batch-trigger-dialog/batch-trigger-dialog.component';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogConfig as MatDialogConfig,
} from '@angular/material/legacy-dialog';
import { LookupService } from '../services/lookup/lookup.service';
import { BulkadjustmentService } from '../services/bulk-adjustment/bulkadjustment.service';
import { PipeLookupService } from '../services/pipe-lookup/pipe-lookup.service';
import { element } from 'protractor';

@Component({
  selector: 'app-llp-jobstatus',
  templateUrl: './llp-jobstatus.component.html',
  styleUrls: ['./llp-jobstatus.component.scss'],
})
export class LlpJobstatusComponent implements OnInit, OnDestroy {
  namcValue = localStorage.getItem('namcvalue');
  namcName = localStorage.getItem('namcName');
  user: string;
  userRole: any;
  successMessage = '';

  public gridColumnApi;
  public columnDefs;
  public columnDefs1;
  public defaultColDef;
  tooltipShowDelay = 0;
  public rowData: any;
  public rowData1: any;

  batchTriggerConfig: any = [];
  frameworkComponents: any;

  userName: string;

  jobGridOptions = {} as any;

  warningMessage = '';

  jobSubscription$: Subscription;
  dateFormat = 'MM/DD/YYYY';
  newDate = String(
    mm()
      .tz(getTimezone(localStorage.getItem('namcvalue')))
      .format(this.dateFormat)
  ).substring(0, 10);

  context: any;
  public modules = [];
  namc: string = '';
  @ViewChild('jobGrid') jobGrid;
  gridApi;

  itContact: string;

  easternCurrentDate: any;

  jobStatusInterval$: any;

  qpcForPart: any;
  access;
  batchRunAllow = false;
  timeZone: string;

  constructor(
    private readonly JobgridService: JobgridService,

    private readonly spinner: NgxSpinnerService,
    private readonly stateService: OSPStateService,

    private readonly pipeJobstatusService: PipeJobstatusService,
    public readonly dialog: MatDialog,
    private readonly lookupservice: LookupService,
    private readonly bulkadjustmentService: BulkadjustmentService,
    private readonly pipeLookup: PipeLookupService
  ) {
    this.frameworkComponents = {
      llpJobstatusBatchTrigger: LlpJobstatusBatchTriggerComponent,
      buttonRenderer: StatusrenderComponent,
    };

    this.context = {
      componentParent: this,
    };
  }
  ngOnDestroy(): void {
    this.jobSubscription$.unsubscribe();

    this.jobStatusInterval$.unsubscribe();
  }
  ngOnInit(): void {
    this.access = checkInvAccess();
    this.batchRunAllow = this.access?.functionalityAccess?.batchRun || false;
    console.log(this.batchRunAllow, 'isrunallow');
    this.jobGridOptions = this.JobgridService.getGridOptions();
    this.jobGridOptions.onGridReady = function (params) {
      params.api.hideOverlay();
      this.gridApi = params.api;
    };
    this.timeZone=getTimezone(this.namcValue);
    console.log("timeZone",this.timeZone);
    localStorage.setItem('timezone', this.timeZone);


    this.columnDefs = [
      {
        headerName: 'Activities',
        field: 'batch_name',

        sortable: false,
        suppressSizeToFit: true,
        width: 285,
        floatingFilter: false,

      },
      {
        headerName: 'Frequency',
        field: 'frequency',

        sortable: false,
        suppressSizeToFit: true,
        width: 150,
        floatingFilter: false,
      },
      {
        headerName: 'Start DateTime',
        field: 'start_date',
        sortable: false,
        width: 190,
        floatingFilter: false,
        headerTooltip: 'mm/dd/yyyy hh:mm:ss (Eastern)',
        cellStyle: function (params) {
          var dateFormat = 'MM/DD/YYYY';
          var newDate = String(
            mm()
              .tz(getTimezone(localStorage.getItem('namcvalue')))
              .format(dateFormat)
          ).substring(0, 10);

          if (
            moment(params.data.start_date).isSame(new Date(newDate), 'day') &&
            moment(params.data.end_date).isSame(new Date(newDate), 'day') &&
            params.data.status === 'COMPLETE'
          ) {
            return { background: 'rgb(225, 255,221)', color: 'rgb(37,170,0)' }; // green color
          }
        },
      },
      {
        headerName: 'End DateTime',
        field: 'end_date',
        sortable: false,
        width: 190,
        floatingFilter: false,
        headerTooltip: 'mm/dd/yyyy hh:mm:ss (Eastern)',
        cellStyle: function (params) {
          var dateFormat = 'MM/DD/YYYY';
          var newDate = String(
            mm()
              .tz(getTimezone(localStorage.getItem('namcvalue')))
              .format(dateFormat)
          ).substring(0, 10);

          if (
            moment(params.data.end_date).isSame(new Date(newDate), 'day') &&
            moment(params.data.start_date).isSame(new Date(newDate), 'day') &&
            params.data.status === 'COMPLETE'
          ) {
            return { background: 'rgb(225, 255,221)', color: 'rgb(37,170,0)' }; // green color
          }
        },
      },
      {
        headerName: 'Duration',
        field: 'duration',
        sortable: false,
        width: 110,
        headerTooltip: 'hh:mm:ss',
        floatingFilter: false,
      },
      {
        headerName: 'User',
        field: 'userid',
        sortable: false,
        width: 230,
        floatingFilter: false,
      },
      {
        headerName: 'On-Demand',
        cellRendererFramework: LlpJobstatusBatchTriggerComponent,
        sortable: false,
        suppressSizeToFit: true,
        field: 'action',
        width: 100,
        floatingFilter: false,
        hide: !this.batchRunAllow,
      },

      {
        headerName: 'Status',
        field: 'status',
        sortable: false,

        width: 120,
        floatingFilter: false,
        cellRendererFramework: StatusrenderComponent,
      },
    ];

    this.jobSubscription$ = this.stateService.getNamc().subscribe((observable) => {
      this.initializeData();
      this.startAutoRefresh();
    });
  }

  startAutoRefresh(): void {
    if (this.jobStatusInterval$) {
      return;
    }

    this.jobStatusInterval$ = interval(autoRefreshInterval)
      .pipe(filter(() => !document.hidden))
      .subscribe(() => {
        this.refresh();
      });
  }

  access1;
  initializeData() {
    this.removeMessage();
    this.spinner.show();

    this.itContact = localStorage.getItem('itContact');

    if (localStorage.getItem('namcName')) {
      this.namcName = localStorage.getItem('namcName');
    }
    if (localStorage.getItem('namcSelected')) {
      this.namc = JSON.parse(localStorage.getItem('namcSelected') as string);
    }
    this.namcValue = localStorage.getItem('namcvalue');

    if (localStorage.getItem('workdayId')) {
      this.user = localStorage.getItem('workdayId');
    }

    if (localStorage.getItem('UserRoles')) {
      this.userRole = localStorage.getItem('UserRoles');
    }
    this.userName = localStorage.getItem('UserName');

    //getjob
    const data = {
      business_entity: this.namcValue,
      business_entity_name: this.namcName,
      workid: this.user,
      user_role: this.userRole,
      easternCurrentDate: String(
        mm()
          .tz(getTimezone(localStorage.getItem('namcvalue')))
          .format('YYYY-MM-DD')
      ),
    };

    const jobApiSubScriptions = [
      this.lookupservice.getLLPJob(data),
      this.lookupservice.getqpcforpart(),
      this.lookupservice.getBatchTriggerNames(),

      // this.pipeJobstatusService.getFile(data),
    ];

    forkJoin(jobApiSubScriptions).subscribe({
      error: this.errorCallback,
      next: (res) => {
        this.batchTriggerConfig = res[2].body;

        if (res[0].body.getJobResponse?.length > 0) {
          for (let k = 0; k < res[0].body.getJobResponse.length; k++) {
            const userId = res[0].body.getJobResponse[k].userid;

            // Check if userid is null or does not include both '(' and ')'
            if (userId === null || !(userId.includes('(') && userId.includes(')'))) {
              res[0].body.getJobResponse[k].userid = 'LLP';
            }
          }

          this.rowData = res[0].body.getJobResponse;
        } else {
          this.rowData = [];
        }

        this.spinner.hide();

        this.qpcForPart = res[1].body.data;
      },
    });
  }

  errorCallback = (error) => {
    console.error(error);
    this.spinner.hide();

    if (error?.error?.message?.required_fields) {
      this.warningMessage = `${warningMessage.requiredFieldsMissing}  ${this.itContact}.`;
    } else {
      this.warningMessage = `${warningMessage.apiLogicFail}  ${this.itContact}.`;
    }
  };

  removeMessage() {
    this.warningMessage = '';
    this.successMessage = '';
  }

  refresh() {
    this.removeMessage();

    this.stateService.setNamc({
      namc: localStorage.getItem('namcSelected'),
      WorkdayID: '',
      Name: '',
      Role: '',
    });

    this.initializeData();
  }
  onBatchTrigger(data) {
    if (
      data.batch_name.toLowerCase() == 'Calc min max inventory batch'.toLowerCase() ||
      data.batch_name.toLowerCase() == 'Usagevsreceipt Calculation batch'.toLowerCase()
    ) {
      this.openDialog(data);
    }
    if (
      data.batch_name.toLowerCase() == 'Monthly Pipeline Addition Batch'.toLowerCase()
    ) {
      this.openDialog(data);
    }

  }

  openDialog(data) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modal-component';
    const isUVRBatch = data?.batch_name?.trim().toLowerCase() === 'usagevsreceipt calculation batch';
    const dateLabelToShow = isUVRBatch ? 'Stocking Date' : 'Start Date';
    const isMonthlyPipeline = data?.batch_name?.trim().toLowerCase() === 'monthly pipeline addition batch';
    dialogConfig.width = isMonthlyPipeline ? '450px' : '650px';
    dialogConfig.height = 'auto';  

    dialogConfig.data = {
      qpcForPart: this.qpcForPart,
      inputParams: this.batchTriggerConfig,
      dataLabel: dateLabelToShow,
      isMonthlyPipeline: isMonthlyPipeline,
      data1: this.rowData
    };

    const dialogRef = this.dialog.open(BatchTriggerDialogComponent, dialogConfig);

    const addGetResponse = dialogRef.componentInstance.editEventEmitter.subscribe((res) => {
      this.spinner.show();

      // Prepare data for getBatchRunLog
      const runlogData = {
        business_entity: this.namcValue,
        workid: this.user,
        user_role: this.userRole,
        NAMC: this.namcName,
        userid: this.userName,
        isinitial: this.batchTriggerConfig.find((element) => data.batch_name === element.batch_name)?.batchmaster_name,
      };

      // Call getBatchRunLog first
      this.lookupservice.getBatcRunLog(runlogData).subscribe(
        (success: any) => {
          // Prepare data to send to calculation API
          const dataToSend = {
            business_entity: this.namcValue,
            workid: this.user,
            user_role: this.userRole,
            NAMC: this.namcName,
            userid: this.userName,
            dock: res.dock,
            part_number: res.item_id,
            batch_name: this.batchTriggerConfig.find((element) => data.batch_name === element.batch_name)
              ?.aws_batchname,
            current_date: res.current_date,
            batchRunLogID: success.body.batchRunLogId,
            rerun: res.rerun     
            };

          // Now call the calculation API
          this.bulkadjustmentService.calculation(dataToSend).subscribe(
            (success) => {
              if (success.body.status === true) {
                this.successMessage = `${data.batch_name} started successfully for your request.`;
                this.initializeData();
                this.spinner.hide();
                window.scroll(0, 0);
              } else {
                this.spinner.hide();
              }
            },
            (err) => {
              this.spinner.hide();
              this.successMessage = '';
              this.warningMessage = `${warningMessage.errorBatchTrigger} ${this.itContact}.`;
              window.scroll(0, 0);
            }
          );
        },
        (error) => {
          this.spinner.hide();
          console.error('Error in getBatchRunLog:', error);
          this.warningMessage = 'Failed to trigger batch run. Please try again.';
          window.scroll(0, 0);
        }
      );
    });

    dialogRef.afterClosed().subscribe(() => {
      addGetResponse.unsubscribe();
    });
  }
}
